import { ConcessionType } from '../domain/types';

export const concessionLabels: { [key in ConcessionType]: string } = {
  [ConcessionType.ALTROCONSUMO]: 'Altroconsumo',
  [ConcessionType.BENEFITHUB]: 'Benefithub',
  [ConcessionType.PICKABU]: 'Pickabu',
};
